import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import Blocks from '../blocks/Blocks';
import Image from '../partials/Image';
// import PropTypes from 'prop-types';
import PageMeta from '../partials/PageMeta';
import Title from '../typography/Title';

import styles from '../../../styles/pages/page.module.css';

const propTypes = { page: PropTypes.shape({ id: PropTypes.string }) };

function Page({ page = null }) {
    const { type = null, layout = null, title = null, blocks = null, image = null } = page || {};
    const hasFirstImageBlock = useMemo(() => {
        const [firstBlock] = blocks || [];
        const { type: blockType = null } = firstBlock || {};
        return blockType === 'image';
    }, [blocks]);

    return (
        <div className={classNames([styles.container, { [styles[type]]: type !== null }])}>
            <PageMeta page={page} />
            <Title size="large">{title}</Title>
            {image !== null && !hasFirstImageBlock ? (
                <Image
                    className={styles.image}
                    image={image}
                    size="large"
                    filtered
                    rounded
                    header
                />
            ) : (
                <div className={styles.spacer} />
            )}
            {blocks !== null && blocks.length > 0 ? (
                <Blocks className={styles.blocks} blocks={blocks} />
            ) : null}
        </div>
    );
}

Page.propTypes = propTypes;

export default Page;
